import pcOfferLetterIndex from './pc/index.vue'
import '@/assets/scss/adaptWrapper.scss'
import { deviceType } from '@/utils/common'
import mobileOfferLetterIndex from './mobile/index.vue'
import BlankLayout from '../layout/blankLayout.vue'

const basePath = '/recruiting/personal/offer-letter'

export default {
  name: 'personalOffer',
  path: `${basePath}`,
  redirect: `${basePath}/edit`,
  component: BlankLayout,
  meta: {
  },
  children: [
    {
      name: 'personalOfferEdit',
      path: `${basePath}/edit`,
      component: deviceType.isPc ? pcOfferLetterIndex : mobileOfferLetterIndex,
      meta: {
        titleI18nKey: 'personal.offerLetter.title.offerLetter'
      }
    }
  ]
}
